import React from 'react';
import { Defs, LinearGradient, Path, Stop } from 'svgs';
import { createLogo } from '../createLogo';

const vectorComponent = () => (
  <>
    <Path
      fill="#000"
      d="M127.111 39H4.889C2.15 39 0 36.855 0 34.125V4.875C0 2.145 2.151 0 4.889 0H127.11C129.849 0 132 2.145 132 4.875v29.25c0 2.73-2.151 4.875-4.889 4.875Z"
    />
    <Path
      fill="#A6A6A6"
      d="M127.11.78c2.249 0 4.107 1.853 4.107 4.095v29.25c0 2.243-1.858 4.095-4.107 4.095H4.89c-2.249 0-4.107-1.853-4.107-4.095V4.875C.783 2.632 2.641.78 4.89.78h122.22zm0-.78H4.89C2.152 0 .001 2.243.001 4.875v29.25C.001 36.855 2.152 39 4.89 39h122.22c2.738 0 4.889-2.145 4.889-4.875V4.875c0-2.632-2.151-4.875-4.889-4.875z"
    />
    <Path
      fill="#fff"
      d="M46.347 9.945c0 .78-.196 1.462-.684 1.95-.587.585-1.271.877-2.151.877s-1.565-.292-2.152-.877c-.586-.585-.88-1.268-.88-2.145 0-.878.294-1.56.88-2.145.587-.585 1.272-.878 2.152-.878.39 0 .782.098 1.173.293s.684.39.88.682l-.49.488c-.39-.488-.88-.683-1.563-.683-.587 0-1.174.195-1.565.683-.489.39-.684.975-.684 1.657 0 .683.195 1.268.684 1.658.489.39.978.682 1.565.682.684 0 1.173-.195 1.662-.682.293-.293.489-.683.489-1.17h-2.151v-.78h2.835v.39zm4.498-2.438h-2.64V9.36h2.444v.682h-2.444v1.853h2.64v.78h-3.422v-5.85h3.422v.682zm3.227 5.168h-.783V7.507h-1.662v-.682h4.107v.682H54.07v5.168zm4.497 0v-5.85h.782v5.85h-.782zm4.107 0h-.782V7.507H60.23v-.682h4.01v.682h-1.663v5.168h.098zm9.289-.78c-.587.585-1.271.877-2.151.877s-1.565-.292-2.151-.877-.88-1.268-.88-2.145c0-.878.293-1.56.88-2.145s1.27-.878 2.15-.878 1.565.293 2.152.878c.586.585.88 1.267.88 2.145 0 .877-.294 1.56-.88 2.145zm-3.716-.488c.391.39.978.683 1.565.683s1.173-.195 1.564-.683c.391-.39.685-.975.685-1.657 0-.683-.196-1.268-.685-1.658-.391-.39-.978-.682-1.564-.682s-1.174.195-1.565.682c-.39.39-.684.975-.684 1.658 0 .682.195 1.267.684 1.657zm5.671 1.268v-5.85h.88l2.836 4.582V6.825h.782v5.85h-.782l-3.031-4.778v4.778h-.685zM66.587 21.255c-2.347 0-4.204 1.755-4.204 4.192a4.167 4.167 0 0 0 4.204 4.193c2.347 0 4.205-1.755 4.205-4.193 0-2.535-1.858-4.192-4.205-4.192zm0 6.63c-1.271 0-2.347-1.073-2.347-2.535s1.076-2.535 2.347-2.535 2.347.975 2.347 2.535c0 1.462-1.076 2.535-2.347 2.535zm-9.093-6.63c-2.347 0-4.205 1.755-4.205 4.192 0 2.34 1.858 4.193 4.205 4.193s4.204-1.755 4.204-4.193c0-2.535-1.858-4.192-4.204-4.192zm0 6.63c-1.271 0-2.347-1.073-2.347-2.535s1.076-2.535 2.347-2.535 2.346.975 2.346 2.535c0 1.462-1.075 2.535-2.346 2.535zM46.64 22.522v1.755h4.204c-.098.975-.489 1.755-.978 2.243-.586.585-1.564 1.267-3.226 1.267-2.64 0-4.596-2.047-4.596-4.68s2.054-4.68 4.596-4.68c1.369 0 2.444.585 3.226 1.268l1.272-1.268c-1.076-.975-2.445-1.755-4.4-1.755-3.52 0-6.552 2.925-6.552 6.435s3.032 6.435 6.552 6.435c1.955 0 3.324-.585 4.497-1.852 1.174-1.17 1.565-2.828 1.565-4.095 0-.39 0-.78-.098-1.073H46.64zm44.39 1.365c-.39-.975-1.368-2.632-3.52-2.632s-3.91 1.657-3.91 4.192c0 2.34 1.76 4.193 4.106 4.193 1.858 0 3.031-1.17 3.423-1.853l-1.37-.975c-.488.683-1.075 1.17-2.053 1.17-.977 0-1.564-.39-2.053-1.267l5.573-2.34-.195-.488zm-5.67 1.365c0-1.56 1.27-2.437 2.15-2.437.685 0 1.37.39 1.565.877l-3.715 1.56zm-4.596 3.998h1.858V17.062h-1.858V29.25zm-2.933-7.118c-.49-.487-1.271-.975-2.25-.975-2.053 0-4.008 1.853-4.008 4.193s1.858 4.095 4.009 4.095c.978 0 1.76-.488 2.15-.975h.099v.585c0 1.56-.88 2.437-2.25 2.437-1.075 0-1.857-.78-2.053-1.462l-1.564.682c.489 1.073 1.662 2.438 3.716 2.438 2.15 0 3.91-1.268 3.91-4.29v-7.41h-1.76v.682zm-2.151 5.753c-1.271 0-2.347-1.073-2.347-2.535s1.075-2.535 2.347-2.535 2.249 1.072 2.249 2.535-.978 2.535-2.25 2.535zm23.858-10.822h-4.4v12.188h1.857v-4.583h2.543c2.053 0 4.009-1.462 4.009-3.802s-1.956-3.803-4.01-3.803zm.097 5.85h-2.64V18.72h2.64c1.369 0 2.152 1.17 2.152 2.048-.098 1.072-.88 2.145-2.152 2.145zm11.244-1.755c-1.369 0-2.738.585-3.227 1.852l1.663.683c.391-.683.977-.878 1.662-.878.978 0 1.858.585 1.955 1.56v.098c-.293-.195-1.075-.488-1.857-.488-1.76 0-3.52.975-3.52 2.73 0 1.658 1.466 2.73 3.031 2.73 1.271 0 1.857-.585 2.346-1.17h.098v.975h1.76v-4.68c-.195-2.145-1.858-3.412-3.91-3.412zm-.196 6.727c-.586 0-1.466-.292-1.466-1.072 0-.975 1.075-1.268 1.955-1.268.783 0 1.174.195 1.663.39-.196 1.17-1.174 1.95-2.152 1.95zm10.267-6.435-2.053 5.265h-.098l-2.15-5.265h-1.957l3.227 7.41-1.858 4.095h1.858l4.987-11.504h-1.956zm-16.427 7.8h1.858V17.063h-1.858V29.25z"
    />
    <Path
      fill="url(#a)"
      d="M10.169 7.313c-.293.292-.391.78-.391 1.365v21.547c0 .585.195 1.072.489 1.365l.098.097 12.124-12.09v-.195l-12.32-12.09z"
    />
    <Path
      fill="url(#b)"
      d="m26.4 23.692-4.009-3.998v-.292l4.009-3.998.098.098 4.79 2.73c1.37.78 1.37 2.047 0 2.828L26.4 23.692z"
    />
    <Path
      fill="url(#c)"
      d="M26.498 23.595 22.391 19.5 10.17 31.688c.49.488 1.174.488 2.054.098l14.276-8.19z"
    />
    <Path
      fill="url(#d)"
      d="M26.498 15.405 12.222 7.313c-.88-.488-1.564-.39-2.053.097L22.39 19.5l4.106-4.095z"
    />
    <Path
      fill="#000"
      d="m26.4 23.498-14.178 7.995c-.782.488-1.467.39-1.956 0l-.097.098.097.097c.49.39 1.174.488 1.956 0l14.178-8.19z"
      opacity={0.2}
    />
    <Path
      fill="#000"
      d="M10.169 31.492c-.293-.292-.391-.78-.391-1.365v.098c0 .585.195 1.072.489 1.365v-.098h-.098zm21.12-10.725-4.889 2.73.098.098 4.791-2.73c.684-.39.978-.878.978-1.365 0 .487-.391.877-.978 1.267z"
      opacity={0.12}
    />
    <Path
      fill="#fff"
      d="m12.222 7.41 19.067 10.823c.587.39.978.78.978 1.268 0-.488-.293-.975-.978-1.365L12.222 7.314c-1.369-.78-2.444-.196-2.444 1.365v.097c0-1.462 1.075-2.145 2.444-1.365z"
      opacity={0.25}
    />
    <Defs>
      <LinearGradient
        id="a"
        x1={21.316}
        x2={4.952}
        y1={8.492}
        y2={24.901}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#00A0FF" />
        <Stop offset={0.007} stopColor="#00A1FF" />
        <Stop offset={0.26} stopColor="#00BEFF" />
        <Stop offset={0.512} stopColor="#00D2FF" />
        <Stop offset={0.76} stopColor="#00DFFF" />
        <Stop offset={1} stopColor="#00E3FF" />
      </LinearGradient>
      <LinearGradient
        id="b"
        x1={33.082}
        x2={9.423}
        y1={19.501}
        y2={19.501}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#FFE000" />
        <Stop offset={0.409} stopColor="#FFBD00" />
        <Stop offset={0.775} stopColor="orange" />
        <Stop offset={1} stopColor="#FF9C00" />
      </LinearGradient>
      <LinearGradient
        id="c"
        x1={24.275}
        x2={2.086}
        y1={21.738}
        y2={43.991}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#FF3A44" />
        <Stop offset={1} stopColor="#C31162" />
      </LinearGradient>
      <LinearGradient
        id="d"
        x1={7.135}
        x2={17.044}
        y1={0.172}
        y2={10.109}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#32A071" />
        <Stop offset={0.069} stopColor="#2DA771" />
        <Stop offset={0.476} stopColor="#15CF74" />
        <Stop offset={0.801} stopColor="#06E775" />
        <Stop offset={1} stopColor="#00F076" />
      </LinearGradient>
    </Defs>
  </>
);

export const PlayStoreLogo = createLogo({
  viewBox: '0 0 132 39',
  vectorComponent
});
